// AuthService.js
import axios from 'axios';
import { BASE_API_URL } from './baseServices';
import { fetchWithAuth } from '../utils/api';

export const signIn = async (credentials) => {
    return axios.post(`${BASE_API_URL}public/SignIn`, credentials, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const fetchModules = async () => {
    try {
      const response = await fetchWithAuth("AdminRoutes/getModules", { method: "GET" });
      const data = await response.json();
      return data.ResultData;
    } catch (error) {
      console.error("Error fetching modules:", error);
      throw error;
    }
  };

  export const forceLogoff = async (payload) => {
    return axios.post(`${BASE_API_URL}AdminRoutes/ForcedSignOut`, payload, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};
